import { Box, Input, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { CopyButton } from './CopyButton';
import { getDataTracking } from '../../utils';

export interface CopyLinkProps {
  buttonVariant?: string;
  copyLinkText?: string;
  copyText?: string;
  url: string;
  trackingLabel?: string;
}

export const CopyLink: FC<CopyLinkProps> = ({
  buttonVariant,
  copyLinkText,
  copyText,
  trackingLabel,
  url,
}) => (
  <>
    <Box width="full">
      <Text fontSize="md" mb={2} color="brand.monochromatic.700">
        {copyText}
      </Text>
      <Input w="100%" value={url} readOnly />
    </Box>
    <Box alignSelf="flex-end" width="full">
      <CopyButton
        url={url}
        w="100%"
        colorScheme="blue"
        variant={buttonVariant}
        {...getDataTracking(`${trackingLabel}${copyLinkText}`)}
      >
        {copyLinkText}
      </CopyButton>
    </Box>
  </>
);
